import { observer } from 'mobx-react-lite'
import { AllOrAnyOfSelect } from '@/features/legends/filters/components/AllOrAnyOfSelect'
import type { HasSkillsEditorViewModel } from '@/features/legends/filters/types/HasSkillsEditorViewModel'

export interface HasSkillsFilterContainerProps {
  vm: HasSkillsEditorViewModel
  isDisabled?: boolean
  testId?: string
}

/**
 * Passes when the pro has all, or any, of the skills.
 */
export const HasSkillsFilterContainer = observer(
  function HasSkillsFilterContainer({
    vm,
    isDisabled,
    testId,
  }: HasSkillsFilterContainerProps) {
    return (
      <AllOrAnyOfSelect
        subject="Pro"
        noun="skills"
        op={vm.op}
        onOpChange={vm.setOp}
        options={vm.availableSkills}
        value={vm.selectedSkillIds}
        onChange={vm.setSkills}
        placeholder="Select skills"
        error={vm.validation.getError('skills')}
        isDisabled={isDisabled}
        aria-label="Skills operation"
        testId={testId}
        optionsTestId={testId && `${testId}-skills`}
      />
    )
  },
)
